import React from 'react';
import { ThreadLastActivityInfoProps } from './ThreadInformation';
import { isDeletedUser } from '../../../types/api/UserProfile';
import { PersonInformation, PersonInformationModifier } from '../../../components/molecules/PersonInformation';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';

export function ThreadLastActivityInfo({ lastActivityInfo }: { lastActivityInfo: ThreadLastActivityInfoProps }) {
  return (
    <div className="thread-list__person-time">
      {isDeletedUser(lastActivityInfo.author) ? (
        <PersonInformation
          profileName={lastActivityInfo.author.profileName}
          profileImageUrl={lastActivityInfo.author.profileImageUrl}
          deletedUser={lastActivityInfo.author.deletedUser}
          modifier={PersonInformationModifier.THREADLIST}
        />
      ) : (
        <PersonInformation
          profileName={lastActivityInfo.author.profileName}
          profileLink={lastActivityInfo.author.profileLink}
          infoCardUrl={lastActivityInfo.author.personInfoCardUrl}
          profileImageUrl={lastActivityInfo.author.profileImageUrl}
          modifier={PersonInformationModifier.THREADLIST}
        />
      )}
      <DateFormat
        date={lastActivityInfo.activityDate}
        format={DateFormats.DATE_TIME}
        className="thread-list__time font-regular-15-19"
      />
    </div>
  );
}
